<save-page pageTitle="Action Views"
           newButtonLabel="NEW ACTION VIEW"
           [tabSetConfig]="tabSetConfig"
           (newButtonClicked)="newActionView()">
</save-page>
